(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ibr-bottom-bar"]) return;
  try {
    
  if (!customElements.get('ibr-bottom-bar')) {
    customElements.define('ibr-bottom-bar', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const dialog = this.querySelector('dialog');
        const opener = this.querySelector('[data-ibr-menu-open]');
        const closer = this.querySelector('[data-ibr-menu-close]');
        let previousOverflow = '';
        opener.addEventListener('click', () => {
          if (dialog.open) return;
          previousOverflow = document.body.style.overflow;
          dialog.showModal();
          document.body.style.overflow = 'hidden';
          opener.setAttribute('aria-expanded', 'true');
        });
        const close = () => { if (dialog.open) dialog.close(); };
        closer.addEventListener('click', close);
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
        });
        dialog.addEventListener('close', () => {
          document.body.style.overflow = previousOverflow;
          opener.setAttribute('aria-expanded', 'false');
          opener.focus({ preventScroll: true });
        });
        this.restorePage = () => { if (dialog.open) document.body.style.overflow = previousOverflow; };
      }
      disconnectedCallback() { if (this.restorePage) this.restorePage(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
